import { render, staticRenderFns } from "./PopupTableDetails.vue?vue&type=template&id=f9f4e518&scoped=true&"
import script from "./PopupTableDetails.vue?vue&type=script&lang=js&"
export * from "./PopupTableDetails.vue?vue&type=script&lang=js&"
import style0 from "./PopupTableDetails.vue?vue&type=style&index=0&id=f9f4e518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f4e518",
  null
  
)

export default component.exports